import {Component, inject, Input, OnInit} from '@angular/core';
import {CartService} from '../services/cart';
import {FormGroup} from '@angular/forms';
import {environment} from '../../environments/environment';
import {Router} from '@angular/router';
import {PaypalService} from '../services/paypal-service';
import {Shared} from '../services/shared';
declare let paypal: any;
@Component({
  selector: 'app-paypal-button',
  imports: [],
  templateUrl: './paypal-button.html',
  styleUrl: './paypal-button.scss'
})
export class PaypalButton implements OnInit {
  sharedService = inject(Shared)
  cartService = inject(CartService)
  // @Input() formGroup!: FormGroup;
  private paypalService = inject(PaypalService)
  private router = inject(Router)
  constructor() {}

  @Input() formGroup!: FormGroup;
  private paypalButtonsRendered = false;

  private hasValidBilling(values: any): boolean {
    // Check required billing fields here
    return values?.email && values?.fullName;
  }
  ngOnInit(): void {

    if (!this.formGroup) return;

    // Subscribe to form status changes
    this.formGroup.statusChanges.subscribe(status => {
      if (status === 'VALID' && !this.paypalButtonsRendered) {
        const billing = this.formGroup.getRawValue();
        this.renderPaypalButtons()
          .catch(err => console.error('PayPal render error:', err));
      }
    });

    // Also check initial status
    if (this.formGroup.valid && !this.paypalButtonsRendered) {
      const billing = this.formGroup.getRawValue();
      this.renderPaypalButtons()
        .catch(err => console.error('Initial PayPal render error:', err));
    }
  }


  private async renderPaypalButtons() {
    const cart = this.cartService.getItems();
    const billing = this.formGroup.getRawValue();

    console.log({ cart, billing });

    try {
      await this.paypalService.loadPaypalSdk();
      this.paypalButtonsRendered = true;
      paypal.Buttons({
        style: {
          shape: 'pill',
          color: 'gold',
          layout: 'vertical',
          label: 'paypal'
        },
        createOrder: async () => {
          const cart = this.cartService.getItems();
          const billing = this.formGroup.getRawValue();
          const res = await fetch(`${environment.apiBaseUrl}/paypal/create-order`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ cart, billing })
          });
          const data = await res.json();
          return data.id;
        },
        onApprove: async (data: any) => {
          const res = await fetch(`${environment.apiBaseUrl}/paypal/capture-order/${data.orderID}`, { method: 'POST' });
          const captureData = await res.json();
          const captured = captureData.capture_response;

          const orderId = captured.id;
          const creditsAdded = captureData.credits_added;
          const amount = captured.purchase_units[0].payments.captures[0].amount.value;
          const payerName = captured.payer.name.given_name + ' ' + captured.payer.name.surname;
          const payerEmail = captured.payer.email_address;
          // console.log(creditsAdded)

          if (captured.status === 'COMPLETED') {
            await this.router.navigate(['/checkout/success'], {
              state: { order: { id: orderId, amount, payerName, payerEmail, creditsAdded } }
            });
            this.sharedService.callNavbarFunction()

          } else {
            // failed pagina
            alert('Payment not completed');
          }
        },
      }).render('#paypal-button-container');

    } catch (err) {
      console.error('Failed to load PayPal SDK', err);
    }
  }
}
